export enum ContractorPaymentTypeEnum {
  PerBoard = 'PerBoard',
  PerHour = 'PerHour',
}
